/**
 * Rolagem até as âncoras do menu.
 *
 * A rolagem suave nativa deixa a duração a cargo do navegador, o que fica
 * lento em saltos longos (topo → rodapé). Aqui a animação tem duração fixa,
 * independente da distância, e é cancelada se a pessoa rolar no meio dela.
 */

const DURACAO = 420

/**
 * Quanto do topo da tela está coberto: a base do header já embute o
 * deslocamento da barra de admin do WordPress quando ela está presente.
 */
function alturaHeader(): number {
  const header = document.querySelector<HTMLElement>('.vd-header')
  return header ? header.getBoundingClientRect().bottom : 0
}

function suavizar(t: number): number {
  return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2
}

let animacao = 0

function pular(topo: number): void {
  window.scrollTo({ top: topo, behavior: 'instant' as ScrollBehavior })
}

function irPara(hash: string): void {
  const alvo = document.querySelector(hash)
  if (!alvo) return

  const inicio = window.scrollY
  const destino = Math.max(
    0,
    Math.round(inicio + alvo.getBoundingClientRect().top - alturaHeader()),
  )
  const distancia = destino - inicio
  if (Math.abs(distancia) < 2) return

  cancelAnimationFrame(animacao)

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    pular(destino)
    return
  }

  const inicioEm = performance.now()
  let cancelado = false

  const cancelar = (): void => {
    cancelado = true
  }
  const opcoes = { passive: true, once: true } as const
  window.addEventListener('wheel', cancelar, opcoes)
  window.addEventListener('touchstart', cancelar, opcoes)
  window.addEventListener('keydown', cancelar, opcoes)

  const limpar = (): void => {
    window.removeEventListener('wheel', cancelar)
    window.removeEventListener('touchstart', cancelar)
    window.removeEventListener('keydown', cancelar)
  }

  const passo = (agora: number): void => {
    if (cancelado) {
      limpar()
      return
    }
    const t = Math.min(1, (agora - inicioEm) / DURACAO)
    pular(inicio + distancia * suavizar(t))
    if (t < 1) {
      animacao = requestAnimationFrame(passo)
      return
    }
    limpar()
  }

  animacao = requestAnimationFrame(passo)
}

document.addEventListener('click', (e) => {
  const link = (e.target as HTMLElement).closest('a[href]')
  if (!link) return

  const href = link.getAttribute('href') ?? ''

  if (href.startsWith('#') && href.length > 1) {
    if (document.querySelector(href)) {
      e.preventDefault()
      history.pushState(null, '', href)
      irPara(href)
    }
    return
  }

  try {
    const url = new URL(href, location.href)
    if (
      url.hash.length > 1 &&
      url.origin === location.origin &&
      url.pathname === location.pathname &&
      document.querySelector(url.hash)
    ) {
      e.preventDefault()
      history.pushState(null, '', url.hash)
      irPara(url.hash)
    }
  } catch {
    /* href relativo ou inválido — deixa o navegador resolver */
  }
})

/* Chegando de outra página com hash na URL. */
window.addEventListener('load', () => {
  if (location.hash.length > 1) {
    setTimeout(() => irPara(location.hash), 200)
  }
})
